import { CancellationFeeExtent } from '@mews-commander/data-access';

export interface WithCancellationPolicyId {
    cancellationPolicyId: string;
}

export enum CancellationPolicyFormField {
    Name = 'name',
    Applicability = 'applicability',
    OffsetType = 'offsetType',
    ApplicabilityOffset = 'applicabilityOffset',
    AbsoluteFeeCurrencyCode = 'absoluteFeeCurrencyCode',
    AbsoluteFee = 'absoluteFee',
    Key = 'key',
    RelativeFee = 'relativeFee',
    FeeMaximumTimeUnits = 'feeMaximumTimeUnits',
    FeeExtent = 'feeExtent',
    BookablePeriod = 'bookablePeriod',
}

export enum CancellationPolicyOffsetType {
    Before = 'Before',
    After = 'After',
}

export enum CancellationFeeExtentFieldOption {
    TimeUnits = CancellationFeeExtent.TimeUnits,
    Products = CancellationFeeExtent.Products,
    TimeUnitsAndProducts = 'TimeUnitsAndProducts',
}
